import gql from 'graphql-tag';

export default gql`
  fragment ScheduledShareItem on ScheduledShareItem {
    id
    network
    network_id
    user_commentary
    share_at
    shared_at
    share_session_id
  }
`;
